import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
//
import Screen from "./ConnectedScreen";
import Alert from "../components/Alert";

const WAIT_SECONDS = 60 * 2; // 2 min

class VerifyPhoneOtpScreen extends Component {
  constructor(props) {
    super(props);

    this.intervalID = null;

    this.state = {
      error: false,
      otp: null,
      seconds: WAIT_SECONDS,
      isCalling: false,
    };
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    if (this.intervalID) {
      clearInterval(this.intervalID);
    }
  }

  startTimer() {
    this.intervalID = setInterval(() => {
      const seconds = this.state.seconds - 1;

      if (seconds === 0) {
        clearInterval(this.intervalID);
      }

      this.setState({ seconds });
    }, 1000);
  }

  enterSubmit(ev) {
    if (ev.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit() {
    const { otp } = this.state;
    const { verifyBooking } = this.props;

    if (otp && otp.length === 4) {
      verifyBooking(otp);
    } else {
      this.setState({
        error: true,
      });
    }
  }

  callMe() {
    this.setState({
      isCalling: true,
      seconds: WAIT_SECONDS,
    });

    this.props.callMe();
  }

  onOtpChange(otp) {
    this.setState({
      otp,
      error: false,
    });
  }

  render() {
    const {
      bookingId,
      errorMessage,
      phoneNumber,
      isVerified,
      verifyBookingManually,
    } = this.props;
    const { otp, seconds, isCalling, error } = this.state;

    return (
      <Screen
        title="Enter OTP code"
        isActive
        className="screen--otp form"
        nextLabel="Verify OTP"
        onBack={false}
        onNext={(ev) => this.onSubmit()}
      >
        <p>
          We have sent a 4 digit OTP code to{" "}
          <span className="u-brand">{phoneNumber}</span>, please enter the code
          below.
        </p>
        <p>It can take up to 3 minutes to receive the code on your phone.</p>
        <br />
        <div className={cx("form__field", { error })}>
          <label>Enter OTP</label>
          <input
            type="number"
            name="otp"
            value={otp || ""}
            className="form__control"
            placeholder="e.g: 1234"
            onChange={(ev) => this.onOtpChange(ev.target.value)}
            autoFocus
            onKeyDown={(ev) => this.enterSubmit(ev)}
          />
          {error && (
            <small className="form__error">OTP code must be 4-digit long</small>
          )}
        </div>
        {seconds > 0 && !isCalling && (
          <p className="u-small u-tm">Try again in {seconds}s...</p>
        )}
        {seconds > 0 && isCalling && (
          <p className="u-small u-tm">
            You will receive a call shortly to{" "}
            <span className="u-brand">{phoneNumber}</span>.
          </p>
        )}
        {seconds === 0 && !isVerified && (
          <Alert info>
            Hmmm... It's taking too long.{" "}
            <a className="u-link" onClick={(ev) => this.callMe()}>
              Call me instead
            </a>
            ?
          </Alert>
        )}
        {seconds === 0 && isVerified && (
          <Alert info>
            Hmmm... It's taking too long.
            <br />
            Would you prefer to{" "}
            <a
              className="u-link"
              onClick={(ev) => verifyBookingManually(bookingId)}
            >
              receive updates by email
            </a>
            ?
          </Alert>
        )}
        {errorMessage !== null && (
          <p className="u-danger u-small u-mt">{errorMessage}</p>
        )}
      </Screen>
    );
  }
}

// @connect
import {
  verifyBookingAction,
  callMeAction,
  setOtpTypeAction,
  verifyBookingManuallyAction,
} from "../modules/booking/actions";

function mapState(state) {
  const { auth, booking } = state;

  return {
    bookingId: booking.id,
    phoneNumber: booking.phone,
    isVerified: auth.verified,
  };
}

function mapDispatch(dispatch) {
  return {
    verifyBooking(otp) {
      dispatch(verifyBookingAction(otp));
    },

    callMe() {
      dispatch(callMeAction());
    },

    verifyByEmail() {
      dispatch(setOtpTypeAction("email"));
    },

    verifyBookingManually(bookingId) {
      dispatch(verifyBookingManuallyAction(bookingId));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(VerifyPhoneOtpScreen);
